import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { getAllLotteryService } from "../../AdminLottery/services/adminLottery.service";
import { useEffect, useState } from "react";
import { AssociateLotteryToUser, DropdownField,} from "../models/adminUsers.model";
import { lotteryActiveDataDropdownAdapter } from "../adapters/adminUser.adapter";
import { Button } from "primereact/button";
import { associateLotteryService } from "../services/adminUser.service";
import { ToastControlBackendModel } from "../../../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";

interface Props {
  getAllUsersData: () => void;
  setDialogLotteryToUser: (data: boolean) => void;
  idUser: number;
  setMessageBackend: (value: ToastControlBackendModel) => void;
}

function FormLotteryToUser({
  getAllUsersData,
  setDialogLotteryToUser,
  idUser,
  setMessageBackend,
}: Props): JSX.Element {
  const [lotteryData, setLotteryData] = useState<DropdownField[]>([]);
  const [lottery, setLottery] = useState<string>();
  const [loading, setLoading] = useState(true);

  const getAllLotteryActive = async () => {
    try {
      const getAllLottery = await getAllLotteryService();
      if (getAllLottery.length > 0) {
        setLotteryData(lotteryActiveDataDropdownAdapter(getAllLottery));
      }
    } catch (error) {
      setMessageBackend({
        detailValue: "Ocurrió un error al obtener los sorteos activos",
        severityValue: "error",
        lifeValue: 3000,
        validateShowMessage: true,
      });
    }
  };

  useEffect(() => {
    getAllLotteryActive();
  }, []);

  useEffect(() => {
    if (lottery) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [lottery]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); // Evita que la página se recargue
    if (!lottery) return;
    
    setLoading(true);
    try {
      const dataForUpdate: AssociateLotteryToUser = {
        idLottery: +lottery,
        idUser: +idUser,
      };
      const response = await associateLotteryService(dataForUpdate);
      if (response) {
        getAllUsersData();
        setDialogLotteryToUser(false);
        setMessageBackend({
          detailValue: "Sorteo asociado con éxito",
          severityValue: "success",
          lifeValue: 3000,
          validateShowMessage: true,
        });
      }
    } catch (error) {
      setMessageBackend({
        detailValue: "Ocurrió un error al asociar el sorteo",
        severityValue: "error",
        lifeValue: 3000,
        validateShowMessage: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // Estilos corporativos para limpiar el Dropdown de PrimeReact
  const dropdownStyle: React.CSSProperties = {
    backgroundColor: "#ffffff",
    border: "1px solid #cbd5e1", // Gris claro slate-300 corporativo
    width: "100%",
    borderRadius: "6px"
  };

  return (
    <div className="w-full px-4 py-3">
      {/* Estilos inyectados para forzar el fondo blanco y colores de texto en el panel desplegable del Dropdown */}
      <style>{`
  .p-dropdown {
    background: #ffffff !important;
  }
  .p-dropdown .p-dropdown-label.p-placeholder {
    color: #64748b !important;
  }
  .p-dropdown .p-dropdown-label {
    color: #333333 !important;
    padding: 0.75rem 1rem !important;
  }
  .p-dropdown-panel {
    background: #ffffff !important;
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
    color: #333333 !important;
    background: #ffffff !important;
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item:hover {
    background: #f1f5f9 !important;
  }
  .p-dropdown-panel .p-dropdown-filter-container {
    background: #ffffff !important;
    padding: 0.5rem !important;
  }

  /* ✅ Estas son las que arreglan el input oscuro del buscador */
  .p-dropdown-panel .p-dropdown-filter {
    background: #ffffff !important;
    color: #333333 !important;
    border: 1px solid #cbd5e1 !important;
  }
  .p-dropdown-panel .p-dropdown-filter::placeholder {
    color: #9ca3af !important;
    opacity: 1 !important;
  }
  .p-dropdown-panel .p-inputtext {
    background: #ffffff !important;
    color: #333333 !important;
  }

  /* ✅ El wrapper del input de búsqueda también tiene fondo oscuro */
  .p-dropdown-panel .p-dropdown-header {
    background: #ffffff !important;
    border-bottom: 1px solid #e5e7eb !important;
    padding: 0.5rem !important;
  }
`}</style>

      <form className="flex flex-column gap-4 w-full" onSubmit={onSubmit}>
        
        {/* Selector: Dropdown Sorteos */}
        <div className="w-full">
          <Dropdown
            filter
            className="w-full"
            style={dropdownStyle}
            placeholder="Elije un sorteo"
            value={lottery}
            options={lotteryData}
            optionLabel="name"
            onChange={(e: DropdownChangeEvent) => setLottery(e.target.value)}
            optionValue="code"
            filterPlaceholder="Buscar sorteo..."
          />
        </div>

        {/* Botón Registrar (Abajo y con estilo unificado) */}
        <div className="w-full mt-1">
          <Button
            type="submit"
            label="Registrar"
            className="w-full text-white font-semibold py-3 border-round"
            style={{
              backgroundColor: "#00A86B",
              borderColor: "#00A86B",
              fontSize: "1.1rem",
            }}
            disabled={loading}
          />
        </div>
      </form>
    </div>
  );
}

export default FormLotteryToUser;